var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 70,
    viewBox: "0 0 81 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_276_3489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5584 34.981V6.37504H46.0477C46.6734 6.37504 47.2992 6.10686 47.6568 5.65989C48.1037 5.21292 48.3719 4.67656 48.3719 4.0508C48.3719 2.79929 47.2992 1.72656 46.0477 1.72656H10.2902C7.87656 1.72656 5.99929 3.69322 5.99929 6.01746V65.5537C5.99929 67.3416 7.51898 68.8613 9.30685 68.8613H72.7764C73.9385 68.8613 74.9219 67.8779 74.9219 66.7158V58.3128H49.6234C48.3719 58.3128 47.1204 58.8492 46.3159 59.7431L42.2038 64.1234H13.8659V44.4568",
    stroke: "black",
    strokeWidth: 1.34091,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3002 37.4844H26.1124C22.8943 37.4844 20.3018 40.0768 20.3018 43.295C20.3018 44.4571 21.2852 45.4404 22.4473 45.4404H74.832V39.6298C74.832 38.4677 73.8487 37.4844 72.6866 37.4844H68.1275",
    stroke: "black",
    strokeWidth: 1.34091,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7266 6.375H26.9205V9.50378C26.9205 10.9341 28.0827 12.0962 29.513 12.0962H41.1341C42.5644 12.0962 43.7266 10.9341 43.7266 9.50378V6.375Z",
    fill: "#F69A4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4927 45.3516H74.832V58.4031H33.4427C31.8336 58.4031 30.4927 57.0621 30.4927 55.4531V45.3516Z",
    stroke: "black",
    strokeWidth: 1.34091,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7266 6.375H26.9205V9.50378C26.9205 10.9341 28.0827 12.0962 29.513 12.0962H41.1341C42.5644 12.0962 43.7266 10.9341 43.7266 9.50378V6.375Z",
    stroke: "black",
    strokeWidth: 1.34091,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7812 22.8223C39.9707 28.6329 30.6737 28.6329 24.8631 22.8223",
    stroke: "black",
    strokeWidth: 1.34091,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0117 19.9629C38.8102 24.1644 31.9269 24.1644 27.7254 19.9629",
    stroke: "black",
    strokeWidth: 1.34091,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1484 17.1914C37.4666 19.8732 33.1757 19.8732 30.4939 17.1914",
    stroke: "black",
    strokeWidth: 1.34091,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4954 45.3513H55.9727L54.2742 42.5801C53.8272 41.8649 53.0227 41.418 52.2181 41.418H32.6409C31.4788 41.418 30.5848 42.3119 30.5848 43.474V45.3513H30.4954Z",
    stroke: "black",
    strokeWidth: 1.34091,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6797 41.418V45.3513",
    stroke: "black",
    strokeWidth: 1.34091,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.418 41.418V45.3513",
    stroke: "black",
    strokeWidth: 1.34091,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1562 41.418V45.3513",
    stroke: "black",
    strokeWidth: 1.34091,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8945 41.418V45.3513",
    stroke: "black",
    strokeWidth: 1.34091,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1525 39.8081C11.4245 39.8081 10.0237 38.4073 10.0237 36.6793C10.0237 34.9513 11.4245 33.5505 13.1525 33.5505C14.8804 33.5505 16.2812 34.9513 16.2812 36.6793C16.2812 38.4073 14.8804 39.8081 13.1525 39.8081Z",
    stroke: "black",
    strokeWidth: 1.34091,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_276_3489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.4544,
    height: 68.8332,
    fill: "white",
    transform: "matrix(-1 0 0 1 80.6445 0.919922)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg04);
export default __webpack_public_path__ + "static/media/04.3d37ea230ceb11b41d301dfaf3ea80b2.svg";
export { ForwardRef as ReactComponent };